import onSmimeItemDecodeFailed from '../actions/onSmimeItemDecodeFailed';
import { ClientItem } from 'owa-mail-store';
import SmimeErrorStateEnum from 'owa-smime-adapter/lib/store/schema/SmimeErrorStateEnum';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import ItemId from 'owa-service/lib/contract/ItemId';
import { trace } from 'owa-trace';
import { mutator } from 'satcheljs';

const onSmimeItemDecodeFailedMutator = actionMessage => {
    const itemId: ItemId = actionMessage.itemId;
    const errorState: SmimeErrorStateEnum = actionMessage.errorState;
    const cachedItem: ClientItem = itemId?.Id && getMailStore().items.get(itemId.Id);
    if (cachedItem) {
        cachedItem.Smime = { isDecoded: false, ErrorState: errorState };
    } else {
        trace.error('SmimeTraceError: Item being decoded should exist');
    }
};

export default mutator(onSmimeItemDecodeFailed, onSmimeItemDecodeFailedMutator);
